import "@sveltejs/kit";
import { b as getMainAlertVisibility, c as getMainAlertContent } from "../../chunks/db.js";
const load = async ({ locals, request }) => {
  const alertVisible = await getMainAlertVisibility();
  const alertContent = await getMainAlertContent();
  return {
    alert: {
      visible: alertVisible,
      content: alertContent
    }
  };
};
export {
  load
};
//# sourceMappingURL=_layout.server.ts.js.map
